(function () {
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
// Uncomment the next lines to use your game instance in the browser
// const Game = require('../modules/Game.class');
// const game = new Game();
document.addEventListener("DOMContentLoaded", function() {
    var restart = function restart() {
        var newGame = confirm("Are you sure you want to start a new game? All progress will be lost.");
        if (newGame) {
            messageLose.style.display = "none";
            messageWin.style.display = "none";
            start();
        }
    };
    var start = function start() {
        board = Array(size).fill().map(function() {
            return Array(size).fill(0);
        });
        score = 0;
        getScore();
        startButton.style.display = "none";
        restartButton.style.display = "inline-block";
        messageFirst.style.display = "none";
        cells.forEach(function(cell) {
            cell.innerHTML = "";
            cell.style.backgroundColor = "#cdc1b4";
        });
        addRandomTile();
        addRandomTile();
        updateBoard();
    };
    var addRandomTile = function addRandomTile() {
        var emptyCells = [];
        for(var i = 0; i < size; i++){
            for(var j = 0; j < size; j++)if (board[i][j] === 0) emptyCells.push({
                x: i,
                y: j
            });
        }
        if (emptyCells.length > 0) {
            var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], x = _emptyCells_Math_floor.x, y = _emptyCells_Math_floor.y;
            board[x][y] = Math.random() < 0.9 ? 2 : 4;
        }
    };
    var updateBoard = function updateBoard() {
        for(var i = 0; i < size; i++)for(var j = 0; j < size; j++){
            var value = board[i][j];
            var cell = cells[i * size + j];
            cell.textContent = value === 0 ? "" : value;
            cell.style.backgroundColor = getTileColor(value);
        }
    };
    var getScore = function getScore() {
        scoreDisplay.textContent = score;
    };
    var updateGame = function updateGame() {
        addRandomTile();
        updateBoard();
        checkGameOver();
        getScore();
    };
    var getTileColor = function getTileColor(value) {
        var colors = {
            0: "#cdc1b4",
            2: "#eee4da",
            4: "#ede0c8",
            8: "#f2b179",
            16: "#f59563",
            32: "#f67c5f",
            64: "#f65e3b",
            128: "#edcf72",
            256: "#edcc61",
            512: "#edc850",
            1024: "#edc53f",
            2048: "#edc22e"
        };
        return colors[value] || "#3c3a32";
    };
    var handleKeyDown = function handleKeyDown(e) {
        switch(e.key){
            case "ArrowUp":
            case "w":
                moveUp();
                break;
            case "ArrowDown":
            case "s":
                moveDown();
                break;
            case "ArrowLeft":
            case "a":
                moveLeft();
                break;
            case "ArrowRight":
            case "d":
                moveRight();
                break;
        }
    };
    var removeKeydownEventListener = function removeKeydownEventListener() {
        document.removeEventListener("keydown", handleKeyDown);
    };
    var slide = function slide(array) {
        var reverse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var newArray = reverse ? (0, $227c6742e0ff6f82$export$71511d61b312f219)(array).reverse() : (0, $227c6742e0ff6f82$export$71511d61b312f219)(array);
        newArray = newArray.filter(function(val) {
            return val !== 0;
        });
        var points = 0;
        for(var i = 0; i < newArray.length - 1; i++)if (newArray[i] === newArray[i + 1]) {
            newArray[i] *= 2;
            newArray[i + 1] = 0;
            points += newArray[i];
        }
        newArray = newArray.filter(function(val) {
            return val !== 0;
        });
        while(newArray.length < size)newArray.push(0);
        if (reverse) newArray = newArray.reverse();
        return {
            newArray: newArray,
            points: points
        };
    };
    var moveLeft = function moveLeft() {
        var _loop = function(i) {
            var row = board[i];
            var result = slide(row);
            var newRow = result.newArray;
            if (newRow.some(function(val, index) {
                return val !== row[index];
            })) moved = true;
            board[i] = newRow;
            score += result.points;
        };
        var originalBoard = JSON.parse(JSON.stringify(board));
        var moved = false;
        for(var i = 0; i < size; i++)_loop(i);
        if (moved && JSON.stringify(originalBoard) !== JSON.stringify(board)) updateGame();
    };
    var moveRight = function moveRight() {
        var _loop = function(i) {
            var row = board[i];
            var result = slide(row, true);
            var newRow = result.newArray;
            if (newRow.some(function(val, index) {
                return val !== row[index];
            })) moved = true;
            board[i] = newRow;
            score += result.points;
        };
        var originalBoard = JSON.parse(JSON.stringify(board));
        var moved = false;
        for(var i = 0; i < size; i++)_loop(i);
        if (moved && JSON.stringify(originalBoard) !== JSON.stringify(board)) updateGame();
    };
    var moveUp = function moveUp() {
        var _loop = function(j) {
            var column = board.map(function(row) {
                return row[j];
            });
            var result = slide(column);
            var newColumn = result.newArray;
            if (newColumn.some(function(val, index) {
                return val !== column[index];
            })) moved = true;
            for(var i = 0; i < size; i++)board[i][j] = newColumn[i];
            score += result.points;
        };
        var originalBoard = JSON.parse(JSON.stringify(board));
        var moved = false;
        for(var j = 0; j < size; j++)_loop(j);
        if (moved && JSON.stringify(originalBoard) !== JSON.stringify(board)) updateGame();
    };
    var moveDown = function moveDown() {
        var _loop = function(j) {
            var column = board.map(function(row) {
                return row[j];
            });
            var result = slide(column, true);
            var newColumn = result.newArray;
            if (newColumn.some(function(val, index) {
                return val !== column[index];
            })) moved = true;
            for(var i = 0; i < size; i++)board[i][j] = newColumn[i];
            score += result.points;
        };
        var originalBoard = JSON.parse(JSON.stringify(board));
        var moved = false;
        for(var j = 0; j < size; j++)_loop(j);
        if (moved && JSON.stringify(originalBoard) !== JSON.stringify(board)) updateGame();
    };
    var checkGameOver = function checkGameOver() {
        if (isGameOver()) messageLose.style.display = "inline-block";
        else if (isGameWon()) {
            messageWin.style.display = "inline-block";
            removeKeydownEventListener();
        }
    };
    var isGameOver = function isGameOver() {
        for(var i = 0; i < size; i++)for(var j = 0; j < size; j++){
            if (board[i][j] === 0) return false;
            if (j < size - 1 && board[i][j] === board[i][j + 1]) return false;
            if (i < size - 1 && board[i][j] === board[i + 1][j]) return false;
        }
        return true;
    };
    var isGameWon = function isGameWon() {
        for(var i = 0; i < size; i++)for(var j = 0; j < size; j++){
            if (board[i][j] === 2048) return true;
        }
        return false;
    };
    var startButton = document.getElementById("start-button");
    var restartButton = document.getElementById("restart-button");
    var scoreDisplay = document.getElementById("score");
    var cells = document.querySelectorAll(".field-cell");
    var messageWin = document.querySelector(".message-win");
    var messageLose = document.querySelector(".message-lose");
    var messageFirst = document.querySelector(".message-start");
    var size = 4;
    var board;
    var score = 0;
    startButton.addEventListener("click", start);
    restartButton.addEventListener("click", restart);
    document.addEventListener("keydown", handleKeyDown);
});

})();
//# sourceMappingURL=index.8f5b7aac.js.map
